import React, { useEffect, useState } from 'react'
import Banner from './Banner';
import MobileInput from '../../components/InputGroup/MobileInput';
import InputText from '../../components/InputGroup/InputText';
import UserDetailForm from './UserDetailForm';
import BorkerDetails from './BorkerDetails';
import SiteVisitVerification from './SiteVisitVerification';
import CaptureImage from './CaptureImage';
import WelcomePage from './WelcomePage';
import CustomerInfo from './CustomerInfo';
import CustomerDetails from './CustomerDetails';
import BrokerVerification from './BrokerVerification';
import { toast } from 'react-toastify';
import { completeProjectVisit, getReVisitCustomerDetailsV2, sendOTP, submitSiteVisitForm, verifyOTP, getSvFormConfig, getRunningSiteVisitsCount, getSourcingManagerByProjectIds } from '../../services/private/site-visit.service';
import BorkerDetailForm from './BrokerDetailForm';
import BrokerRegistration from './BrokerRegistrationModal';
import { useLocation, useParams } from 'react-router-dom';
import CPRegistration from './CPRegistration';
import AppQRCode from './AppQRCode';
import CustomerRevisitModal from './Modal/CustomerRevisitModal';
import SiteVisitOTPModal from '../TabletForm/Modal/SiteVisitOTPModal';
import VerifyIdentityModal from '../TabletForm/Modal/VerifyIdentityModal';
import ActiveSiteVisitsModal from './Modal/ActiveSiteVisitsModal';
import { resolveSourcingManagerOption, getResolvedSourcingManagerId } from './sourcingManagerUtils';

const PROJECT_ID_MAP = {
  default: 608,
  yf: 2364,
  av: 2366,
  eg: 2368,
  kera: 2372,
  rivereast: 2376
};

const SiteVisitFlow = () => {
  // Testing Parameters Flag - Set to false to clear testing parameters
  const ENABLE_TESTING_DATA = false;

  const [channerPartner, setChannelPartner] = useState('1');
  const [isWithCP, setIsWithCP] = useState(false);
  const [detail, setDetail] = useState({
    name: ENABLE_TESTING_DATA ? 'Test Customer' : '',
    email: ENABLE_TESTING_DATA ? 'test.customer@gmail.com' : '',
    address: '',
    company: '',
    profession: '',
    designation: '',
    panNo: '',
    aadhar: '',
    pincode: '',
    age: '',
  })
  const [name, setName] = useState(ENABLE_TESTING_DATA ? 'Test Customer' : '')
  const [mobile, setMobile] = useState(ENABLE_TESTING_DATA ? '911234567890' : '');
  const [altMobile, setAltMobile] = useState('');
  const [aboutProject, setAboutProject] = useState('');
  const [preference, setPrefrence] = useState('2 BHK');
  const [investement, setInvestment] = useState('45L-50L');
  const [purpose, setPurpose] = useState('end use');
  const [possessionPreference, setPossessionPreference] = useState('Dec 25')
  const [brokerCode, setBrokerCode] = useState('');
  const [image, setImage] = useState('');
  const [otp, setOTP] = useState('');
  const [otpVerifield, setOTPVerified] = useState(false);
  const [otpError, setOtpError] = useState(false);
  const [siteHeadOtpError, setSiteHeadOtpError] = useState(false);
  const [brokerName, setBrokerName] = useState('');
  const [brokerMobile, setBrokerMobile] = useState('');
  const [companyId, setCompanyId] = useState('');
  const [companyName, setCompanyName] = useState('');
  const [ownerMobile, setOwnerMobile] = useState('');
  const [ownerMail, setOwnerMail] = useState('');
  const [ownerName, setOwnerName] = useState('');
  const [others, setOthers] = useState('')
  const [referralName, setReferralName] = useState('')
  const [referralMobile, setReferralMobile] = useState('');
  const [society, setSociety] = useState('');
  const [flatNo, setFlatNo] = useState('');
  const [imgUrl, setImgUrl] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [newBrokerName, setNewBrokerName] = useState('');
  const [newBrokerMobile, setNewBrokerMobile] = useState('');
  const [type, setType] = useState('')
  const [isCPVisit, setIsCPVisit] = useState(false);
  const [rera, setRera] = useState('');
  const [closingManager, setClosingManager] = useState(null);
  const [countDown, setCountDown] = useState(30);
  const [disableResend, setDisableResend] = useState(true);
  const [showMobileField, setShowMobileField] = useState(true);
  const [showCloseConfirmationModal, setShowCloseConfirmationModal] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [customerData, setCustomerData] = useState('');
  const [showCustomerRevisitModal, setShowCustomerRevisitModal] = useState(false);
  const [note, setNote] = useState('');
  const [cpContactUuid, setCpContactUuid] = useState(null);
  const [isRevisit, setIsRevisit] = useState(false);
  const [isChangeTagging, setIsChangeTagging] = useState(false);
  const [existingTagging, setExistingTagging] = useState(null);
  const [isCancelInternalVisit, setIsCancelInternalVisit] = useState(false);
  const [showSiteVisitOTPModal, setShowSiteVisitOTPModal] = useState(false);
  const [showVerifyIdentityModal, setShowVerifyIdentityModal] = useState(false);
  const [city, setCity] = useState('');
  const [isWithoutMobile, setIsWithoutMobile] = useState(false);
  const [customerUuid, setCustomerUuid] = useState('');
  const [docName, setDocName] = useState('');
  const [docId, setDocId] = useState('');
  const [docUrl, setDocUrl] = useState('');
  const [isReraUpdated, setIsReraUpdated] = useState(false);
  const [previousStepBeforeCapture, setPreviousStepBeforeCapture] = useState('4');

  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);
  const { projectKey } = useParams();
  const [projectId, setProjectId] = useState(() => {
    if (projectKey && !isNaN(projectKey)) {
      return parseInt(projectKey, 10);
    }
    return PROJECT_ID_MAP[projectKey] || PROJECT_ID_MAP.default;
  });
  const [projectName, setProjectName] = useState('Krystal One');
  const [formConfig, setFormConfig] = useState(null);
  const [branding, setBranding] = useState(null);
  const [loadingConfig, setLoadingConfig] = useState(true);
  const [coverImage, setCoverImage] = useState(null);
  const [runningVisitsCount, setRunningVisitsCount] = useState(0);
  const [showActiveVisitsModal, setShowActiveVisitsModal] = useState(false);
  const [sourcingManager, setSourcingManager] = useState(null);
  const [sourcingManagerSource, setSourcingManagerSource] = useState(null);
  const [allSourcingManagers, setAllSourcingManagers] = useState([]);
  const [isSourcingRefreshing, setIsSourcingRefreshing] = useState(false);

  const fetchSourcingManagers = async () => {
    if (!projectId) return;
    setIsSourcingRefreshing(true);
    try {
      const res = await getSourcingManagerByProjectIds({ project_ids: [projectId] });
      const rawList = res?.data?.data || res?.data || [];
      if ((res?.data?.status === 200 || res?.status === 200) && Array.isArray(rawList) && rawList.length > 0) {
        const managers = rawList.map((user) => resolveSourcingManagerOption(user, rawList));
        setAllSourcingManagers(managers);
        // If sourcingManager was already set from lead with only UUID before managers loaded, enrich it now
        setSourcingManager((prev) => (prev ? resolveSourcingManagerOption(prev, managers) : null));
      } else {
        setAllSourcingManagers([]);
      }
    } catch (err) {
      console.log("Error fetching sourcing managers:", err);
      setAllSourcingManagers([]);
    } finally {
      setIsSourcingRefreshing(false);
    }
  };

  const fetchRunningVisitsCount = async (targetProjectId = projectId) => {
    try {
      const res = await getRunningSiteVisitsCount({ project_id: targetProjectId, projectId: targetProjectId });
      if (res?.data?.status === 200 || res?.status === 200) {
        const count = res?.data?.data?.count ?? res?.data?.count ?? 0;
        setRunningVisitsCount(count);
      }
    } catch (err) {
      console.log("Error fetching running site visits count:", err);
    }
  };

  useEffect(() => {
    fetchRunningVisitsCount(projectId);
    fetchSourcingManagers();
  }, [projectId]);

  useEffect(() => {
    const key = projectKey || 'default';
    let id;
    if (key && !isNaN(key)) {
      id = parseInt(key, 10);
    } else {
      id = PROJECT_ID_MAP[key] || PROJECT_ID_MAP.default;
    }
    setProjectId(id);
    setFormConfig(null);
    setBranding(null);
    setLoadingConfig(true);

    getSvFormConfig({ project_id: id })
      .then(res => {
        if (res.data.status === 200) {
          const data = res.data.data;
          setProjectName(data.project_name || 'Krystal One');
          setFormConfig(data.form_config);
          setBranding(data.branding);
          setCoverImage(data.cover || data.branding?.cover || null);

          // Populate default inventory preferences from response
          if (data.form_config?.inventory_preference?.fields) {
            data.form_config.inventory_preference.fields.forEach(field => {
              if (field.key === 'possession_preference' && field.default) {
                setPossessionPreference(field.default);
              } else if (field.key === 'preference' && field.default) {
                setPrefrence(field.default);
              } else if (field.key === 'investement' && field.default) {
                setInvestment(field.default);
              } else if (field.key === 'purpose' && field.default) {
                setPurpose(field.default);
              }
            });
          }
        }
      })
      .catch(err => {
        console.error("Failed to load SV Form Config", err);
      })
      .finally(() => {
        setLoadingConfig(false);
      });
  }, [projectKey]);


  useEffect(() => {
    if (!localStorage.getItem('authToken')) {
      const key = projectKey || '2058';
      window.location.href = `/login/${key}`;
    }
    document.body.classList.add('hide-chat-widget');
    return () => {
      document.body.classList.remove('hide-chat-widget');
    };
  }, [projectKey]);

  useEffect(() => {
    if (searchParams.get('type')) {
      setType(searchParams.get('type'))
    }
  }, [searchParams.get('type')]);

  useEffect(() => {
    let timer = setInterval(() => {
      if (countDown <= 0) {
        clearInterval(timer);
        setDisableResend(false);
      } else {
        setCountDown(countDown - 1)
      }
    }, 1000)

    return (() => clearInterval(timer))
  }, [countDown])

  useEffect(() => {
    if (name) {
      setDetail({ ...detail, name: name })
    }

  }, [name])

  const handleChangeDetail = (e) => {
    setDetail({ ...detail, [e.target.name]: e.target.value })
  }

  const [masterOtpError, setMasterOtpError] = useState(false);

  const handleSubmitData = async (otp, siteHeadOtp, masterOtpMeta = {}) => {
    setIsSubmitting(true)
    setOtpError(false)
    setSiteHeadOtpError(false)
    setMasterOtpError(false)
    const payload = {
      otp: otp,
      site_head_otp: siteHeadOtp || null,
      customer_name: name || detail.name || null,
      customer_mobile: mobile || null,
      project_id: projectId,
      broker_code: brokerCode || null,
      email: detail.email || null,
      address: detail.address || null,
      company: detail.company || null,
      profession: detail.profession || null,
      designation: detail.designation || null,
      pan_no: detail.panNo || null,
      aadhar: detail.aadhar || null,
      preference: preference || null,
      investement: investement || null,
      purpose: purpose || null,
      image: imgUrl || null,
      alt_mobile: altMobile || null,
      about_project: isWithCP ? 'CP' : aboutProject,
      broker_company_id: (cpContactUuid || companyId?.data?.type === 'contact') ? null : (companyId?.value || null),
      broker_name: brokerName || newBrokerName || null,
      broker_mobile: brokerMobile || newBrokerMobile || null,
      broker_company_name: companyName || null,
      company_owner_name: ownerName || null,
      company_owner_mobile: ownerMobile || null,
      company_owner_email: ownerMail || null,
      possession_preference: possessionPreference || null,
      rera_number: rera || null,
      is_rera_updated: isReraUpdated || false,
      cp_contact_uuid: cpContactUuid || null,
      existing_tagging: existingTagging || null,
      reference_name: referralName || null,
      reference_mobile: referralMobile || null,
      reference_flat_no: flatNo || null,
      reference_society: society || null,
      other_source: others || null,
      note: note || null,
      pincode: detail.pincode || null,
      age: detail.age || null,
      city: city || null,
      is_without_mobile: isWithoutMobile || null,
      customer_uuid: customerUuid || null,
      doc_name: docName || null,
      doc_id: docId || null,
      doc_url: docUrl || null,
      closing_user_uuid: closingManager?.value || null,
      sourcing_manager_id: isWithCP ? getResolvedSourcingManagerId(sourcingManager, allSourcingManagers) : null,
      is_cancel_internal_visit: isCancelInternalVisit || false,
      is_revisit: isRevisit || false,
    }

    if (masterOtpMeta?.isMasterOtp) {
      payload.is_master_otp = true;
      payload.master_otp_reason = masterOtpMeta.masterOtpReason;
      if (masterOtpMeta.masterOtpReason === 'other' && masterOtpMeta.masterOtpReasonText) {
        payload.master_otp_reason_text = masterOtpMeta.masterOtpReasonText.trim();
      }
    }

    try {
      const res = await submitSiteVisitForm(payload, { type });
      if (res.data.status === 200) {
        // toast.success(res.data.message);
        setOTPVerified(true);
        fetchRunningVisitsCount();
      }
    } catch (err) {
      toast.error(err.response?.data?.message || 'Something went wrong')
      console.log(err.response?.data?.message)
      const errMsg = err?.response?.data?.message || '';
      if (errMsg.toLowerCase().includes('site head') || errMsg.toLowerCase().includes('sitehead')) {
        setSiteHeadOtpError(true);
      } else if (errMsg === 'Incorrect OTP') {
        if (masterOtpMeta?.isMasterOtp) {
          setMasterOtpError(true);
        } else {
          setOtpError(true);
        }
      }
    } finally {
      setIsSubmitting(false)
    }
  }

  const handleGetReVisitCustomerDetails = async (phone, isCpValue) => {
    setIsRevisit(false);
    setClosingManager(null);
    setSourcingManager(null);
    setSourcingManagerSource(null);
    setIsCancelInternalVisit(false);
    setIsChangeTagging(false);
    setExistingTagging(null);
    setOtpError(false);
    setSiteHeadOtpError(false);
    const payload = {
      mobile: phone.substring(2),
      project_id: projectId,
    }
    try {
      const res = await getReVisitCustomerDetailsV2(payload);
      if (res.data.status === 200) {
        const apiData = res.data.data;

        // If data doesn't exist at all, redirect directly to Customer Details
        if (!apiData || (!apiData.latest_completed_visit && !apiData.latest_scheduled_visit && !apiData.lead_info)) {
          setChannelPartner('3');
          return;
        }

        // Determine if we should show the Revisit Modal
        // 1. Has completed visit -> ALWAYS show modal
        // 2. Has scheduled visit AND CP check-in -> SHOW modal
        const hasCompleted = !!apiData.latest_completed_visit;
        const hasScheduled = !!apiData.latest_scheduled_visit;
        const cpCheck = isCpValue !== undefined ? isCpValue : isWithCP;

        if (hasCompleted || (hasScheduled && cpCheck)) {
          setCustomerData(apiData);
          setShowCustomerRevisitModal(true);
          setIsRevisit(hasCompleted);
        } else {
          // New customer with only scheduled visit (no completed visit) or no visit at all
          setShowCustomerRevisitModal(false);
          setChannelPartner('3');
        }

        // Use the best available source to pre-fill the form details
        const customerDetailsSource = apiData.latest_completed_visit || apiData.latest_scheduled_visit || apiData.lead_info;

        if (customerDetailsSource) {
          const closingManagerName = apiData.lead_info?.closing_user_name || customerDetailsSource?.closing_user_name;
          const closingManagerUuid = apiData.lead_info?.closing_user_uuid || customerDetailsSource?.closing_user_uuid || null;

          if (closingManagerName) {
            setClosingManager({
              label: closingManagerName,
              value: closingManagerUuid || null
            });
          }

          // Prefill Sourcing Manager as per Backend Doc section 2
          if (apiData.sourcing_manager && (apiData.sourcing_manager.id || apiData.sourcing_manager.name || apiData.sourcing_manager.uuid)) {
            const resolvedSM = resolveSourcingManagerOption(apiData.sourcing_manager, allSourcingManagers);
            setSourcingManager(resolvedSM);
            setSourcingManagerSource(apiData.sourcing_manager.source || 'lead');
          } else {
            const sourcingManagerName = apiData.lead_info?.sourcing_user_name || customerDetailsSource?.sourcing_user_name;
            const sourcingManagerUuid = apiData.lead_info?.sourcing_user_uuid || customerDetailsSource?.sourcing_user_uuid || null;

            if (sourcingManagerName || sourcingManagerUuid) {
              const resolvedSM = resolveSourcingManagerOption({
                name: sourcingManagerName,
                uuid: sourcingManagerUuid
              }, allSourcingManagers);
              setSourcingManager(resolvedSM);
              setSourcingManagerSource('lead');
            } else {
              setSourcingManager(null);
              setSourcingManagerSource(null);
            }
          }

          // Update name
          const customerName = customerDetailsSource.name || apiData.lead_info?.name;
          if (customerName) {
            setDetail(prev => ({ ...prev, name: customerName }));
            setName(customerName);
          }

          // Update email & other details
          const customerEmail = customerDetailsSource.customer_email || customerDetailsSource.email;
          if (customerEmail || customerDetailsSource.address || customerDetailsSource.profession || customerDetailsSource.designation || customerDetailsSource.pan_no || customerDetailsSource.aadhar || customerDetailsSource.company) {
            setDetail(prev => ({
              ...prev,
              email: customerEmail || prev.email || null,
              address: customerDetailsSource.address || prev.address || '',
              profession: customerDetailsSource.profession || prev.profession || null,
              designation: customerDetailsSource.designation || prev.designation || null,
              panNo: customerDetailsSource.pan_no || prev.panNo || null,
              aadhar: customerDetailsSource.aadhar || prev.aadhar || null,
              company: customerDetailsSource.company || prev.company || ''
            }));
          }

          // Update preference (property configuration)
          const preferredConfig = customerDetailsSource.preferred_configurations;
          if (preferredConfig) {
            setPrefrence(Array.isArray(preferredConfig) ? preferredConfig[0] : preferredConfig);
          }

          // Update investment (budget range)
          if (customerDetailsSource.budget) {
            setInvestment(`${customerDetailsSource.budget}`);
          } else if (customerDetailsSource.min_budget && customerDetailsSource.max_budget) {
            // format budget helper
            const min = (parseInt(customerDetailsSource.min_budget) / 100000).toFixed(1) + 'L';
            const max = (parseInt(customerDetailsSource.max_budget) / 100000).toFixed(1) + 'L';
            setInvestment(`${min}-${max}`);
          }

          // Update purpose
          if (customerDetailsSource.purpose) {
            setPurpose(customerDetailsSource.purpose);
          }

          if (customerDetailsSource.reference_name) {
            setReferralName(customerDetailsSource.reference_name);
          }
          if (customerDetailsSource.reference_mobile) {
            setReferralMobile(customerDetailsSource.reference_mobile);
          }
          if (customerDetailsSource.reference_flat_no) {
            setFlatNo(customerDetailsSource.reference_flat_no);
          }
          if (customerDetailsSource.reference_society) {
            setSociety(customerDetailsSource.reference_society);
          }

          // Update possession preference
          if (customerDetailsSource.possession) {
            setPossessionPreference(customerDetailsSource.possession);
          }
        }
      }
    } catch (err) {
      toast.error(err.response?.data?.message || 'Something went wrong');
      console.log(err);
      setChannelPartner('3');
    }
  }

  const handleSubmitCPVisit = async (otp, masterOtpMeta = {}) => {
    setIsSubmitting(true)
    const effectiveBrokerCompanyId = (cpContactUuid || companyId?.data?.type === 'contact') ? null : (companyId?.value || null);
    const resolvedSourcingUserId = getResolvedSourcingManagerId(sourcingManager, allSourcingManagers);
    const payload = {
      otp: otp,
      visitor_name: newBrokerName || brokerName,
      visitor_mobile: newBrokerMobile || brokerMobile,
      project_id: projectId,
      firm_name: companyName,
      owner_name: ownerName,
      owner_mobile: effectiveBrokerCompanyId ? null : ownerMobile,
      broker_company_id: effectiveBrokerCompanyId,
      sourcing_user_id: resolvedSourcingUserId || null,
      image_url: imgUrl, //new
      email: ownerMail, //new
      rera_number: rera || null,
      is_rera_updated: isReraUpdated || false,
      is_master_otp: masterOtpMeta?.is_master_otp || false,
      ...(masterOtpMeta?.is_master_otp && {
        master_otp_reason: masterOtpMeta.master_otp_reason,
        master_otp_reason_text: masterOtpMeta.master_otp_reason === 'other' ? (masterOtpMeta.master_otp_reason_text || null) : null
      })
    }
    try {
      const res = await completeProjectVisit(payload);
      if (res.data.status === 200) {
        setChannelPartner('10');
      }
    } catch (err) {
      toast.error(err.response?.data?.message || 'Something went wrong')
      console.log(err.response?.data?.message)
      if (err.response?.data?.message === 'Incorrect OTP') {
        if (masterOtpMeta?.is_master_otp) {
          setMasterOtpError(true);
        } else {
          setOtpError(true);
        }
      }
    } finally {
      setIsSubmitting(false)
    }
  }

  const handleSendOTP = async () => {
    setIsLoading(true)
    const targetMobile = isCPVisit ? (newBrokerMobile || brokerMobile) : (mobile || newBrokerMobile);
    const targetName = isCPVisit ? (newBrokerName || brokerName) : (detail.name || newBrokerName);
    const payload = {
      mobile: targetMobile,
      email: detail.email || ownerMail,
      customer_name: targetName,
      projectId: projectId
    }
    try {
      // let params = { project: projectId }
      // const res = await sendOTP(payload, params);
      const res = await sendOTP(payload);
      if (res.data.status === 200) {
        toast.success(res.data.message);
        setCountDown(30);
        setDisableResend(true);
        setChannelPartner('6')
        setIsLoading(false);
        setShowCustomerRevisitModal(false)
      }
    } catch (err) {
      toast.error(err.response.data.message)
      if (err.response.data.data.remaining) {
        setChannelPartner('6')
      }
      setIsLoading(false);
      setShowCustomerRevisitModal(false)
    }
  }

  // const handleVerifyOTP = async (otp) => {
  //   const payload = {
  //     mobile: mobile,
  //     otp: otp
  //   }
  //   try {
  //     const res = await verifyOTP(payload);
  //     if (res.data.status === 200) {
  //       handleSubmitData();
  //     }
  //   } catch (err) {
  //     toast.error(err.response.data.message)
  //     setOtpError(true);
  //   }
  // }

  useEffect(() => {
    const unloadCallback = (event) => {
      event.preventDefault();
      event.returnValue = "";
      return "";
    };
    const handleBackButton = () => {
      // console.log('browser baack')
      // const splitedPath = pathname.split('/');
      // if ((splitedPath.includes('new-integration') ||
      //     splitedPath[splitedPath.length - 1].split('?').includes('new-integration')) && steps < 4) {
      //     }
      setShowCloseConfirmationModal(true);
    }

    window.addEventListener("popstate", handleBackButton);
    window.addEventListener("beforeunload", unloadCallback);

    return () => {
      window.removeEventListener("popstate", handleBackButton);
      window.removeEventListener("beforeunload", unloadCallback);
    };

  }, []);

  return (
    <div className='bg-[#F8FAFB] !pt-0 sm:!pt-0 !px-3 sm:!px-6 !pb-3 sm:!pb-6 w-full sm:w-[1024px] mx-auto overflow-auto relative'>
      {channerPartner === '1' && <div className='!pb-0'>
        <WelcomePage 
          setChannelPartner={setChannelPartner} 
          branding={branding} 
          loadingConfig={loadingConfig} 
          activeVisitsCount={runningVisitsCount}
          onOpenActiveVisitsModal={() => setShowActiveVisitsModal(true)}
        />
      </div>}
      {channerPartner === '2' && <CustomerInfo
        name={name}
        setName={setName}
        mobile={mobile}
        setMobile={setMobile}
        setChannelPartner={setChannelPartner}
        setIsWithCP={setIsWithCP}
        setIsCPVisit={setIsCPVisit}
        setShowSiteVisitOTPModal={setShowSiteVisitOTPModal}
        handleGetReVisitCustomerDetails={handleGetReVisitCustomerDetails}
        coverImage={coverImage}
        projectName={projectName}
        brandLogo={branding?.brand_logo}
        activeVisitsCount={runningVisitsCount}
        onOpenActiveVisitsModal={() => setShowActiveVisitsModal(true)}
        setSourcingManager={setSourcingManager}
        setSourcingManagerSource={setSourcingManagerSource}
      />}
      {
        channerPartner === '3' && <CustomerDetails
          setChannelPartner={setChannelPartner}
          isWithCP={isWithCP}
          setIsWithCP={setIsWithCP}
          detail={detail}
          preference={preference}
          setPrefrence={setPrefrence}
          investement={investement}
          setInvestment={setInvestment}
          purpose={purpose}
          setPurpose={setPurpose}
          altMobile={altMobile}
          setAltMobile={setAltMobile}
          mobile={mobile}
          setMobile={setMobile}
          setAboutProject={setAboutProject}
          aboutProject={aboutProject}
          handleChangeDetail={handleChangeDetail}
          possessionPreference={possessionPreference}
          setPossessionPreference={setPossessionPreference}
          others={others}
          setOthers={setOthers}
          referralMobile={referralMobile}
          setReferralMobile={setReferralMobile}
          referralName={referralName}
          setReferralName={setReferralName}
          society={society}
          setSociety={setSociety}
          flatNo={flatNo}
          setFlatNo={setFlatNo}
          city={city}
          setCity={setCity}
          closingManager={closingManager}
          setClosingManager={setClosingManager}
          isRevisit={isRevisit}
          projectId={projectId}
          formConfig={formConfig}
          projectName={projectName}
        />
      }
      {
        channerPartner === '4' && <BorkerDetailForm
          setChannelPartner={setChannelPartner}
          isWithCP={isWithCP}
          isCPVisit={isCPVisit}
          setBrokerName={setBrokerName}
          setBrokerMobile={setBrokerMobile}
          setNewBrokerName={setNewBrokerName}
          setNewBrokerMobile={setNewBrokerMobile}
          setCompanyId={setCompanyId}
          brokerName={brokerName}
          brokerMobile={brokerMobile}
          companyId={companyId}
          coverImage={coverImage}
          projectName={projectName}
          rera={rera}
          setRera={setRera}
          setOwnerName={setOwnerName}
          setOwnerMobile={setOwnerMobile}
          setCompanyName={setCompanyName}
          cpContactUuid={cpContactUuid}
          setCpContactUuid={setCpContactUuid}
          setIsReraUpdated={setIsReraUpdated}
          setPreviousStepBeforeCapture={setPreviousStepBeforeCapture}
          sourcingManager={sourcingManager}
          setSourcingManager={setSourcingManager}
          sourcingManagerSource={sourcingManagerSource}
          setSourcingManagerSource={setSourcingManagerSource}
          allSourcingManagers={allSourcingManagers}
          fetchSourcingManagers={fetchSourcingManagers}
          isSourcingRefreshing={isSourcingRefreshing}
          isRevisit={isRevisit}
          projectId={projectId}
        />
      }
      {
        channerPartner === '8' && <BrokerRegistration
          setChannelPartner={setChannelPartner}
          isWithCP={isWithCP}
          isCPVisit={isCPVisit}
          ownerName={ownerName}
          setOwnerName={setOwnerName}
          ownerMobile={ownerMobile}
          setOwnerMobile={setOwnerMobile}
          email={ownerMail}
          setEmail={setOwnerMail}
          name={newBrokerName}
          setName={setNewBrokerName}
          mobile={newBrokerMobile}
          setMobile={setNewBrokerMobile}
          companyName={companyName}
          setCompanyName={setCompanyName}
          setCompanyId={setCompanyId}
          rera={rera}
          setRera={setRera}
          coverImage={coverImage}
          projectName={projectName}
          cpContactUuid={cpContactUuid}
          setPreviousStepBeforeCapture={setPreviousStepBeforeCapture}
          sourcingManager={sourcingManager}
          setSourcingManager={setSourcingManager}
          sourcingManagerSource={sourcingManagerSource}
          setSourcingManagerSource={setSourcingManagerSource}
          allSourcingManagers={allSourcingManagers}
          fetchSourcingManagers={fetchSourcingManagers}
          isSourcingRefreshing={isSourcingRefreshing}
          isRevisit={isRevisit}
          projectId={projectId}
        />
      }
      {
        channerPartner === '9' && <CPRegistration
          setChannelPartner={setChannelPartner}
          isWithCP={isWithCP}
          ownerName={ownerName}
          setOwnerName={setOwnerName}
          ownerMobile={ownerMobile}
          setOwnerMobile={setOwnerMobile}
          email={ownerMail}
          setEmail={setOwnerMail}
          name={newBrokerName}
          setName={setNewBrokerName}
          mobile={newBrokerMobile}
          setMobile={setNewBrokerMobile}
          companyName={companyName}
          setCompanyName={setCompanyName}
          setCompanyId={setCompanyId}
          projectName={projectName}
          setShowMobileField={setShowMobileField}
          showMobileField={showMobileField}
          coverImage={coverImage}
        />
      }
      {
        channerPartner === '5' && <CaptureImage
          setChannelPartner={setChannelPartner}
          setImage={setImage}
          image={image}
          handleSendOTP={handleSendOTP}
          isWithCP={isWithCP}
          name={name}
          mobile={mobile}
          setImgUrl={setImgUrl}
          isLoading={isLoading}
          setIsLoading={setIsLoading}
          type={type}
          isCPVisit={isCPVisit}
          previousStepBeforeCapture={previousStepBeforeCapture}
        />
      }
      {
        channerPartner === '6' && <SiteVisitVerification
          otpError={otpError}
          masterOtpError={masterOtpError}
          siteHeadOtpError={siteHeadOtpError}
          setChannelPartner={setChannelPartner}
          otpVerifield={otpVerifield}
          setOTP={setOTP}
          handleVerifyOTP={handleSubmitData}
          mobile={isCPVisit ? newBrokerMobile : mobile}
          handleSendOTP={handleSendOTP}
          name={detail?.name}
          countDown={countDown}
          disableResend={disableResend}
          email={detail.email}
          isCPVisit={isCPVisit}
          handleSubmitCPVisit={handleSubmitCPVisit}
          isSubmitting={isSubmitting}
          setShowCustomerRevisitModal={setShowCustomerRevisitModal}
          isRevisit={isRevisit}
          isChangeTagging={isChangeTagging}
          coverImage={coverImage}
          projectName={projectName}
        />
      }
      {
        channerPartner === '7' && <BrokerVerification
          setChannelPartner={setChannelPartner}
          coverImage={coverImage}
          projectName={projectName}
        />
      }
      {
        channerPartner === '10' && <AppQRCode
          setChannelPartner={setChannelPartner}
          coverImage={coverImage}
          projectName={projectName}
        />
      }
      {
        showCustomerRevisitModal && <CustomerRevisitModal
          show={showCustomerRevisitModal}
          closeModal={() => { setShowCustomerRevisitModal(false) }}
          customerData={customerData}
          note={note}
          setNote={setNote}
          handleSendOTP={handleSendOTP}
          setChannelPartner={setChannelPartner}
          isWithCP={isWithCP}
          setIsWithCP={setIsWithCP}
          setCompanyId={setCompanyId}
          setBrokerName={setBrokerName}
          setBrokerMobile={setBrokerMobile}
          setCompanyName={setCompanyName}
          setIsChangeTagging={setIsChangeTagging}
          setExistingTagging={setExistingTagging}
          setRera={setRera}
          isCancelInternalVisit={isCancelInternalVisit}
          setIsCancelInternalVisit={setIsCancelInternalVisit}
        />
      }
      {
        showSiteVisitOTPModal && <SiteVisitOTPModal
          show={showSiteVisitOTPModal}
          closeModal={() => setShowSiteVisitOTPModal(false)}
          setShowVerifyIdentityModal={setShowVerifyIdentityModal}
        />

      }
      {
        showVerifyIdentityModal && <VerifyIdentityModal
          show={showVerifyIdentityModal}
          closeModal={() => setShowVerifyIdentityModal(false)}
        />
      }
      {
        showActiveVisitsModal && <ActiveSiteVisitsModal
          show={showActiveVisitsModal}
          closeModal={() => {
            setShowActiveVisitsModal(false);
            fetchRunningVisitsCount();
          }}
          onCountUpdate={(newCount) => setRunningVisitsCount(newCount)}
          projectId={projectId}
        />
      }
    </div>
  )
}

export default SiteVisitFlow;